export const API = "API";
export const ENDPOINTS = "Endpoints";
